<template>
  <markdown-viewer :title="title" :markdown-content-raw="markdownContentRaw" />
</template>

<script>
import MarkdownViewer from './markdown-viewer.vue';
import otjMarkdown from './markdown_docs/otj.md?raw';

export default {
  name: 'OtjGuidance',
  components: {
    MarkdownViewer,
  },
  data() {
    return {
      title: 'Logging OTJ Hours in EDUKATE',
      markdownContentRaw: otjMarkdown,
    };
  },
};
</script>
